import { render, staticRenderFns } from "./comparyAlarmDetail.vue?vue&type=template&id=42e2f253&scoped=true"
import script from "./comparyAlarmDetail.vue?vue&type=script&lang=js"
export * from "./comparyAlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./comparyAlarmDetail.vue?vue&type=style&index=0&id=42e2f253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e2f253",
  null
  
)

export default component.exports